// Helper functions for tour URL slugs

export function generateTourSlug(style: string, city: string | undefined): string {
  const styleMap: Record<string, string> = {
    'must-do': 'MustSee',
    'best-rated': 'Best',
    'off-the-beaten-path': 'Authentic'
  };
  
  const styleSlug = styleMap[style] || 'Tour';
  const citySlug = (city || 'Unknown').trim().replace(/\s+/g, '-');
  
  return `${styleSlug}_${citySlug}`;
}

export function parseTourSlug(slug: string): { style: string; city: string } | null {
  const parts = slug.split('_');
  if (parts.length < 2) return null;
  
  const styleSlug = parts[0];
  const citySlug = parts.slice(1).join('_');
  
  const reverseStyleMap: Record<string, string> = {
    'MustSee': 'must-do',
    'Best': 'best-rated',
    'Authentic': 'off-the-beaten-path'
  };
  
  const style = reverseStyleMap[styleSlug] || styleSlug;
  const city = citySlug.replace(/-/g, ' ');
  
  return { style, city };
}
